import { render, staticRenderFns } from "./App5BarChart.vue?vue&type=template&id=a4320c84&scoped=true&"
import script from "./App5BarChart.vue?vue&type=script&lang=js&"
export * from "./App5BarChart.vue?vue&type=script&lang=js&"
import style0 from "./App5BarChart.vue?vue&type=style&index=0&id=a4320c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4320c84",
  null
  
)

export default component.exports